const STORAGE_KEY = 'vellum-signup-state';
const popup = document.querySelector('[data-vellum-signup]');

if (popup instanceof HTMLDialogElement) {
  const form = popup.closest('form');
  const formPanel = popup.querySelector('[data-vellum-signup-panel="form"]');
  const successPanel = popup.querySelector('[data-vellum-signup-panel="success"]');
  const message = popup.querySelector('[data-vellum-signup-message]');
  const submit = popup.querySelector('[data-vellum-signup-submit]');
  const copy = popup.querySelector('[data-vellum-signup-copy]');
  const closeButtons = popup.querySelectorAll('[data-vellum-signup-close]');
  const isSuccess = popup.dataset.success === 'true';

  const readState = () => {
    try { return localStorage.getItem(STORAGE_KEY); } catch (error) { return null; }
  };

  const writeState = (value) => {
    try { localStorage.setItem(STORAGE_KEY, value); } catch (error) {}
  };

  const show = () => {
    if (popup.open) return;
    popup.showModal();
    requestAnimationFrame(() => popup.classList.add('is-visible'));
  };

  const close = () => {
    popup.classList.remove('is-visible');
    writeState(isSuccess || successPanel?.classList.contains('is-active') ? 'converted' : 'dismissed');
    window.setTimeout(() => {
      if (popup.open) popup.close();
    }, 420);
  };

  const showSuccess = () => {
    formPanel?.classList.remove('is-active');
    formPanel?.classList.add('is-leaving');
    formPanel?.setAttribute('aria-hidden', 'true');
    window.setTimeout(() => {
      successPanel?.classList.add('is-active');
      successPanel?.setAttribute('aria-hidden', 'false');
      copy?.focus();
    }, 260);
    writeState('converted');
  };

  closeButtons.forEach((button) => button.addEventListener('click', close));
  popup.addEventListener('cancel', (event) => {
    event.preventDefault();
    close();
  });
  popup.addEventListener('click', (event) => {
    if (event.target === popup) close();
  });

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!(form instanceof HTMLFormElement) || !(submit instanceof HTMLButtonElement)) return;
    if (!form.reportValidity()) return;

    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    if (message) message.textContent = '';

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
      });

      const html = await response.text();
      const subscribed = response.ok && (response.url.includes('customer_posted=true') || html.includes('data-success="true"'));
      if (!subscribed) throw new Error('Subscription was not confirmed');
      showSuccess();
    } catch (error) {
      if (message) message.textContent = popup.dataset.errorMessage || '';
    } finally {
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
    }
  });

  copy?.addEventListener('click', async () => {
    const code = popup.dataset.discountCode || 'VELLUM10';
    try {
      await navigator.clipboard.writeText(code);
      copy.textContent = popup.dataset.copiedMessage || 'Copied';
    } catch (error) {
      const selection = window.getSelection();
      const range = document.createRange();
      const codeElement = popup.querySelector('[data-vellum-signup-code] span');
      if (selection && codeElement) {
        range.selectNodeContents(codeElement);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  });

  if (isSuccess) {
    show();
  } else if (!readState() && !window.Shopify?.designMode) {
    window.setTimeout(show, 3500);
  }

  if (window.Shopify?.designMode) show();
}
